<template>
    <v-container fluid :style="{'background-color':$store.getters.getColorPalette().backgroundColorCode}">
        <v-row>
            <v-col cols="12">
                <OEMTable />
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import OEMTable from '@/components/lists/OEMTable'
export default {
    name:'OEMDevicesPage',
    components:{
        OEMTable
    }
}
</script>